/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Status_ClassifiedInputs */

const en_doc_status_classified = /** @type {(inputs: Doc_Status_ClassifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classified`)
};

const pt_br2_doc_status_classified = /** @type {(inputs: Doc_Status_ClassifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificado`)
};

/**
* | output |
* | --- |
* | "Classified" |
*
* @param {Doc_Status_ClassifiedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_status_classified = /** @type {((inputs?: Doc_Status_ClassifiedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Status_ClassifiedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_status_classified(inputs)
	return pt_br2_doc_status_classified(inputs)
});